<template>
    <footer>
        <div class="nav-main">
            <div class="container">
                <div class="row">
                    <router-link to="/" class="col-xs-3 btn-icon btn-icon--home" exact>Accueil</router-link>
                    <router-link to="/services/budget" @click.native="navigateToBudget" class="col-xs-3 btn-icon btn-icon--budget" exact>Mon budget</router-link>
                    <router-link to="/services/calendar" @click.native="navigateToCalendar" class="col-xs-3 btn-icon btn-icon--calendar" exact>Mon agenda</router-link>
                    <router-link to="/services/contacts" @click.native="navigateToContacts" class="col-xs-3 btn-icon btn-icon--contacts" exact>Contacts</router-link>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import {eventBus} from '../main';

    export default {
        data() {
            return {

            }
        },
        methods: {
            //https://vuejs.org/v2/guide/components.html#Using-v-on-with-Custom-Events
            //il faut utiliser @click.native (ou v-on:click.native) pour que les evenements soit actifs sur router-link
            navigateToBudget() {
                eventBus.$emit("changeService", '<span>Mon budget</span> communication');
            },
            navigateToCalendar() {
                eventBus.$emit("changeService", '<span>Mon agenda</span> communication');
            },
            navigateToContacts() {
                eventBus.$emit("changeService", '<span>Mes contacts</span> Art & Fenêtres');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Footer.vue?1f0fe369